import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import withAnimation from '../../../hooks/withAnimation';
import { routeNames } from '../../../routes/routeNames';

const testimonials = [
  {
    name: 'Sumi Patty',
    rating: 5,
    content: 'I am taking physiotherapy from Dr. Disha. Before signing up with FlexifyMe, due to chronic back pain I could hardly do anything and cannot sit for more than 2 hours. Every night I used to go to bed with pain. After a couple of sessions with Dr. Disha...',
    readMore: '#'
  },
  {
    name: 'Richa Jaiswal',
    rating: 5,
    content: 'First of all, I would like to thank the FlexifyMe app from where I got connected to my Dr. Pratiksha who is too dedicated not only with her work but also reducing and understanding her patient’s stress. She is the very best physiotherapist. The exercises which is...',
    readMore: '#'
  },
  {
    name: 'Vinayaka Soratoor',
    rating: 5,
    content: 'Great experience and recovery for back pain. I was suffering from back pain due to my IT life and constant lifting of my toddler. Flexify sessions have really helped me overcome the back pain...',
    readMore: '#'
  },
  {
    name: 'Frau Werner',
    rating: 5,
    content: 'My journey started in March 2024. I am 57 years old and according to my daily work at a desk, my back pain was very high. I have had 3 times sloped discs in my lower back. My latest MRT was 2...',
    readMore: '#'
  }
];

const HealingStories = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="bg-gradient-to-t from-primarylight to-primary py-16 font-primary relative">
      <div className="absolute inset-0 z-0 bg-cover bg-center opacity-10" style={{ backgroundImage: `url('/path-to-background-image.jpg')` }}></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className='flex flex-col justify-between items-center mb-8 lg:flex-row'>
          <h2 className="text-3xl text-white pb-4 font-bold border-b-4 border-secondary lg:text-5xl">Healing Stories</h2>
          <div className="flex justify-center mt-6 lg:mt=0">
            <select className="bg-white border border-gray-300 text-gray-700 py-2 px-4 pr-8 rounded-2xl leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
              <option>Lower Back Pain</option>
              <option>Neck Pain</option>
              <option>Shoulder Pain</option>
              <option>Knee Pain</option>
              <option>Arthritis</option>
            </select>
          </div>
        </div>
        <Slider className='mx-4 lg:mx-0' {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-4">
              <div className="relative bg-white rounded-lg shadow-lg p-6 h-full flex flex-col justify-between transition transform hover:-translate-y-2 hover:shadow-2xl">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-secondary"></div>
                <div className="flex items-center mb-4">
                  
                  <h3 className="text-2xl font-bold">{testimonial.name}</h3>
                  
                </div>
                <div className="flex items-center mb-4">
                  {Array(testimonial.rating).fill().map((_, i) => (
                    <svg key={i} className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927C9.335 2.13 10.665 2.13 10.951 2.927L12.362 7.11C12.477 7.451 12.791 7.676 13.146 7.676H17.546C18.392 7.676 18.791 8.747 18.149 9.226L14.367 12.123C14.095 12.333 13.973 12.724 14.087 13.061L15.498 17.244C15.784 18.041 14.796 18.713 14.155 18.234L10.373 15.337C10.101 15.127 9.899 15.127 9.627 15.337L5.845 18.234C5.204 18.713 4.216 18.041 4.502 17.244L5.913 13.061C6.027 12.724 5.905 12.333 5.633 12.123L1.851 9.226C1.209 8.747 1.608 7.676 2.454 7.676H6.854C7.209 7.676 7.523 7.451 7.638 7.11L9.049 2.927Z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 mb-4 text-justify">{testimonial.content}</p>
                <a href={routeNames.testinomialsDetail} className="text-green font-semibold mt-auto">Read more</a>
              </div>
            </div>
          ))}
        </Slider>
        <Slider className='mx-4 lg:mx-0' {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-4">
              <div className="relative bg-white rounded-lg shadow-lg p-6 h-full flex flex-col justify-between transition transform hover:-translate-y-2 hover:shadow-2xl">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-secondary"></div>
                <div className="flex items-center mb-4">
                  
                  <h3 className="text-2xl font-bold">{testimonial.name}</h3>
                  
                </div>
                <div className="flex items-center mb-4">
                  {Array(testimonial.rating).fill().map((_, i) => (
                    <svg key={i} className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927C9.335 2.13 10.665 2.13 10.951 2.927L12.362 7.11C12.477 7.451 12.791 7.676 13.146 7.676H17.546C18.392 7.676 18.791 8.747 18.149 9.226L14.367 12.123C14.095 12.333 13.973 12.724 14.087 13.061L15.498 17.244C15.784 18.041 14.796 18.713 14.155 18.234L10.373 15.337C10.101 15.127 9.899 15.127 9.627 15.337L5.845 18.234C5.204 18.713 4.216 18.041 4.502 17.244L5.913 13.061C6.027 12.724 5.905 12.333 5.633 12.123L1.851 9.226C1.209 8.747 1.608 7.676 2.454 7.676H6.854C7.209 7.676 7.523 7.451 7.638 7.11L9.049 2.927Z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 font-sans mb-4 ">{testimonial.content}</p>
                <a href={routeNames.testinomialsDetail} className="text-green font-semibold mt-auto">Read more</a>
              </div>
            </div>
          ))}
        </Slider>
        <Slider className='mx-4 lg:mx-0' {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-4">
              <div className="relative bg-white rounded-lg shadow-lg p-6 h-full flex flex-col justify-between transition transform hover:-translate-y-2 hover:shadow-2xl">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-secondary"></div>
                <div className="flex items-center mb-4">
                  
                  <h3 className="text-2xl font-bold">{testimonial.name}</h3>
                  
                </div>
                <div className="flex items-center mb-4">
                  {Array(testimonial.rating).fill().map((_, i) => (
                    <svg key={i} className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927C9.335 2.13 10.665 2.13 10.951 2.927L12.362 7.11C12.477 7.451 12.791 7.676 13.146 7.676H17.546C18.392 7.676 18.791 8.747 18.149 9.226L14.367 12.123C14.095 12.333 13.973 12.724 14.087 13.061L15.498 17.244C15.784 18.041 14.796 18.713 14.155 18.234L10.373 15.337C10.101 15.127 9.899 15.127 9.627 15.337L5.845 18.234C5.204 18.713 4.216 18.041 4.502 17.244L5.913 13.061C6.027 12.724 5.905 12.333 5.633 12.123L1.851 9.226C1.209 8.747 1.608 7.676 2.454 7.676H6.854C7.209 7.676 7.523 7.451 7.638 7.11L9.049 2.927Z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 mb-4 text-justify">{testimonial.content}</p>
                <a href={routeNames.testinomialsDetail} className="text-green font-semibold mt-auto">Read more</a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default withAnimation(HealingStories);
